import * as $ from 'jquery';

export const Infobar = (():any => {

    const Selector = {
        INFOBAR: '.main-header #info-bar',
        DESKTOP_STICKY: '#desktop-header-sticky',
        MAINCONTAINER: '#api-input',
    };

    let infoBarHeight = 0;
    let stickyHeaderHeight = 0;

    // Only run on desktop - mobile uses CSS sticky positioning
    const isMobile = () => window.innerWidth < 768;

    init();
    recalculateHeights();
    window.addEventListener('resize', recalculateHeights);
    window.addEventListener('resize', init);
    window.addEventListener('scroll', init);

    function getElementHeight(selector: string): number {
        const $el = $(selector);
        return $el.length > 0 ? $el.outerHeight() || 0 : 0;
    }

    function recalculateHeights() {
        infoBarHeight = getElementHeight(Selector.INFOBAR);
        stickyHeaderHeight = getElementHeight(Selector.DESKTOP_STICKY);
    }

    function init() {
        // Skip on mobile - header behavior is handled by CSS sticky positioning
        if (isMobile()) {
            $(Selector.DESKTOP_STICKY).removeClass('fixed-top');
            $(Selector.MAINCONTAINER).css('padding-top', '0px');
            return;
        }
        
        // Make header sticky after scrolling past info-bar
        if (window.pageYOffset > infoBarHeight) {
            $(Selector.DESKTOP_STICKY).addClass('fixed-top');
            $(Selector.MAINCONTAINER).css('padding-top', stickyHeaderHeight + 'px');
        } else {
            $(Selector.DESKTOP_STICKY).removeClass('fixed-top');
            $(Selector.MAINCONTAINER).css('padding-top', '0px');
        }
    }

})();
import * as $ from 'jquery';

export const Infobar = (():any => {

    const Selector = {
        INFOBAR: '.main-header #info-bar',
        DESKTOP_STICKY: '#desktop-header-sticky',
        MAINCONTAINER: '#api-input',
    };

    let infoBarHeight = 0;
    let stickyHeaderHeight = 0;

    // Only run on desktop - mobile uses CSS sticky positioning
    const isMobile = () => window.innerWidth < 768;

    init();
    recalculateHeights();
    window.addEventListener('resize', recalculateHeights);
    window.addEventListener('resize', init);
    window.addEventListener('scroll', init);

    function getElementHeight(selector: string): number {
        const $el = $(selector);
        return $el.length > 0 ? $el.outerHeight() || 0 : 0;
    }

    function recalculateHeights() {
        infoBarHeight = getElementHeight(Selector.INFOBAR);
        stickyHeaderHeight = getElementHeight(Selector.DESKTOP_STICKY);
    }

    function init() {
        // Skip on mobile - header behavior is handled by CSS sticky positioning
        if (isMobile()) {
            $(Selector.DESKTOP_STICKY).removeClass('fixed-top');
            $(Selector.MAINCONTAINER).css('padding-top', '0px');
            return;
        }
        
        // Make header sticky after scrolling past info-bar
        if (window.pageYOffset > infoBarHeight) {
            $(Selector.DESKTOP_STICKY).addClass('fixed-top');
            $(Selector.MAINCONTAINER).css('padding-top', stickyHeaderHeight + 'px');
        } else {
            $(Selector.DESKTOP_STICKY).removeClass('fixed-top');
            $(Selector.MAINCONTAINER).css('padding-top', '0px');
        }
    }

})();
